if (!customElements.get("header-inline-search")) {
  class HeaderInlineSearch extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector("[data-inline-search-input]");
      this.results = this.querySelector("[data-inline-search-results]");
      this.trending = this.querySelector("[data-inline-search-trending]");
      this.spinner = this.querySelector("[data-inline-search-spinner]");
      this.cache = {};
      this.minLength = 2;

      if (!this.input || !this.results) return;

      this.input.addEventListener("input", this._debounce(this._onInput.bind(this), 300));
    }

    _debounce(fn, wait) {
      let t;
      return function () {
        const ctx = this;
        const args = arguments;
        clearTimeout(t);
        t = setTimeout(() => fn.apply(ctx, args), wait);
      };
    }

    _onInput() {
      const q = (this.input.value || "").trim();
      if (q.length < this.minLength) {
        this._toggleSpinner(false);
        this._showTrending();
        return;
      }
      this._fetch(q);
    }

    _showTrending() {
      this.results.innerHTML = "";
      this.results.hidden = true;
      if (this.trending) this.trending.hidden = false;
    }

    _showResults() {
      if (this.trending) this.trending.hidden = true;
      this.results.hidden = false;
    }

    _toggleSpinner(show) {
      if (this.spinner) this.spinner.hidden = !show;
    }

    _escape(str) {
      const d = document.createElement("div");
      d.textContent = str;
      return d.innerHTML;
    }

    _fetch(q) {
      if (this.cache[q] !== undefined) {
        this._render(this.cache[q]);
        return;
      }
      this._toggleSpinner(true);

      const routes = (window.MinimogSettings && window.MinimogSettings.routes) || {};
      const base = routes.predictive_search_url || "/search/suggest";
      const fields = "title,product_type,vendor,variants.sku,variants.title";
      const url =
        base +
        "?q=" + encodeURIComponent(q) +
        "&resources[options][unavailable_products]=last" +
        "&resources[options][fields]=" + fields +
        "&section_id=predictive-search";

      fetch(url)
        .then((res) => (res.ok ? res.text() : Promise.reject(res.status)))
        .then((text) => {
          const node = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector("#shopify-section-predictive-search");
          const markup = node ? node.innerHTML.trim() : "";
          this.cache[q] = markup;
          this._render(markup);
        })
        .catch(() => {
          this._toggleSpinner(false);
        });
    }

    _render(markup) {
      this._toggleSpinner(false);
      this.results.innerHTML = markup;

      const wrapper = this.results.querySelector("[data-search-items-wrapper]");
      const hasResults = markup && (!wrapper || wrapper.childElementCount > 0);
      if (!hasResults) {
        const msg = this.results.dataset.noResults || "No results found";
        const term = (this.input.value || "").trim();
        this.results.innerHTML =
          '<p class="m-header__search-empty">' + msg + ' "' + this._escape(term) + '"</p>';
      }
      this._showResults();
    }
  }

  customElements.define("header-inline-search", HeaderInlineSearch);
}
